module.exports = __webpack_public_path__ + "img/RMerchantTransport64_ua.086205f9.webp";